import React, { useEffect, useState, useContext, useCallback } from "react";
import {
  useForm,
  FormProvider,
  useFormContext,
  useWatch,
} from "react-hook-form";
import moment from "moment";
//Function
import { getReportUsage } from "../api";
import {
  ApiDateTimeFormat,
  ToDateText,
  ToMonthText,
} from "../../../utils/date";
//Material Ui
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
//Component
import { BaseContainer } from "../../../stories/base-container";
import Criteria from "../criteria";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ReportTable from "../table";
//Context
import {
  LoadingContext,
  withLoadingContext,
} from "../../../context/loading-context";
const columnsData = [
  {
    id: "CDR_TYPE",
    label: "CDR_TYPE",
    minWidth: 170,
    align: "center",
    dataAlign: "left",
  },
  {
    id: "RECORD_T1",
    label: "T1",
    minWidth: 170,
    align: "center",
    dataAlign: "right",
  },
  {
    id: "RECORD_T3",
    label: "T3",
    minWidth: 170,
    align: "center",
    dataAlign: "right",
  },
  {
    id: "RECORD_DIFF",
    label: "AMOUNT_DIFF",
    minWidth: 170,
    align: "center",
    dataAlign: "right",
  },
  {
    id: "AMOUNT_T1",
    label: "AMOUNT_T1",
    minWidth: 170,
    align: "center",
    dataAlign: "right",
  },
  {
    id: "AMOUNT_T3",
    label: "AMOUNT_T3",
    minWidth: 170,
    align: "center",
    dataAlign: "right",
  },
  {
    id: "AMOUNT_DIFF",
    label: "AMOUNT_DIFF",
    minWidth: 170,
    align: "center",
    dataAlign: "right",
  },
];
const customheader = (color) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell rowSpan={2} align="center">
          CDR Type
        </TableCell>
        <TableCell colSpan={3} align="center">
          # of Records
        </TableCell>
        <TableCell colSpan={3} align="center">
          Amount
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell align="center">T1</TableCell>
        <TableCell align="center">T3</TableCell>
        <TableCell align="center" style={{ backgroundColor: color }}>
          Different
        </TableCell>
        <TableCell align="center">T1</TableCell>
        <TableCell align="center">T3</TableCell>
        <TableCell align="center" style={{ backgroundColor: color }}>
          Different
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
function Usage() {
  const methods = useForm({
    defaultValues: { date: moment().format(ApiDateTimeFormat) },
  });
  const Loading_context = useContext(LoadingContext);
  const { actions: load_actions } = Loading_context;
  const [Data_lst, setData_lst] = useState([]);
  const [date, setDate] = useState();
  const { getValues } = methods;
  const query = useCallback(async () => {
    let param = getValues();
    let dat = await load_actions.withLoading(() => getReportUsage(param));
    if (!dat) return;
    setData_lst(dat?.Data?.Rows);
    setDate(ToDateText(dat?.Date));
  }, [load_actions, getValues]);
  useEffect(() => {
    query();
  }, [query]);
  //changeColor(columnsDom, "DIF", Dom_lst[0]?.DIFF_COLOR_CODE);
  return (
    <FormProvider {...methods}>
      <BaseContainer>
        {Loading_context.state?.isLoading ? (
          <div className="lineLoading">
            <LinearProgress />
          </div>
        ) : null}
        <Box display="flex" justifyContent="center">
          <Typography variant="h4"> Usage T1-T3 Report</Typography>
        </Box>
        <Criteria query={query} />
        <Box display="flex" justifyContent="center">{`Date :${
          date || ""
        }`}</Box>
        <ReportTable
          header={customheader}
          data={Data_lst}
          columns={columnsData}
          cellColor={[
            { fieldId: "RECORD_DIFF", fieldColor: "DIFF_RECORDS_COLOR_CODE" },
            { fieldId: "AMOUNT_DIFF", fieldColor: "DIFF_AMOUNT_COLOR_CODE" },
          ]}
        />
      </BaseContainer>
    </FormProvider>
  );
}
export default withLoadingContext(Usage);
